export const ROOT = '';
export const HOME = 'saltate-la-fila';
